<template>
  <div class="Processline">
    <div class="tag">
      <div class="triangle"></div>
      <div class="triangle darker"></div>
    </div>
  </div>
</template>

<script>
 export default {
   name: '',
   props: {
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Processline{
   width: 100%;
   height: 6vw;
   display: flex;
   align-items:center;
   justify-content:center;
   position: relative;
 }
 .tag{
   position: absolute;
 }
 .triangle{
   width: 0;
   height: 0;
   border-left: 3px solid transparent;
   border-right: 3px solid transparent;
   border-top: 6px solid #5a5aFF;
 }
</style>
